import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'default-passive-events'
// import animated from 'animate.css'
// Vue.use(animated)
import 'animate.css'
Vue.use(ElementUI);
Vue.prototype.$baseUrl = 'https://console.miclass.net';
// 
// Vue.prototype.$baseUrl = 'http://console-uat.miclass.net';
import {getItem,setItem,removeItem,get,set,remove} from './utils/storage'
Vue.prototype.$getItem = getItem
Vue.prototype.$setItem = setItem
Vue.prototype.$removeItem = removeItem
Vue.prototype.$getCookie = get
Vue.prototype.$setCookie = set
Vue.prototype.$removeCookie = remove
new Vue({
  router,
  store,
  render: h => h(App),
  mounted () {
    document.dispatchEvent(new Event('render-event'))
  }
}).$mount('#app')
